import { isArray, isString } from "lodash";

import { AnswerFormValues } from "../types/ReportFormTypes";
import {
  AnswerFragment,
  AnswerTypeEnum,
  QuestionTypeEnum,
} from "../../../graphql/generated/definitions";

export function getAnswerValue(answer: AnswerFragment): string {
  switch (answer.type) {
    case "AnswerText":
      return answer.value;
    case "AnswerSelectorSingle":
      return answer.value.selector;
    case "AnswerSelectorMultiple":
      return answer.value.selector;
    case "AnswerEvaluation":
      return answer.value.selector;
    case "AnswerSkill":
      return answer.value.selector;
  }
}

export function getAnswerDefaultValue(type: QuestionTypeEnum): string {
  switch (type) {
    case "QuestionText":
      return "";
    case "QuestionSelectorSingle":
      return "";
    case "QuestionSelectorMultiple":
      return "";
    case "QuestionEvaluation":
      return "";
    case "QuestionSkill":
      return "";
  }
}

export function getAnswerTypeFromQuestionType(
  type: QuestionTypeEnum
): AnswerTypeEnum {
  switch (type) {
    case "QuestionText":
      return "AnswerText";
    case "QuestionSelectorSingle":
      return "AnswerSelectorSingle";
    case "QuestionSelectorMultiple":
      return "AnswerSelectorMultiple";
    case "QuestionEvaluation":
      return "AnswerEvaluation";
    case "QuestionSkill":
      return "AnswerSkill";
  }
}

export function coerceToAnswerValue({
  type,
  value,
  comment,
}: Pick<AnswerFormValues, "type" | "value" | "comment">) {
  switch (type) {
    case "AnswerText":
      return value;
    case "AnswerSelectorSingle":
      return { selector: value, ...(comment && { comment }) };
    case "AnswerSelectorMultiple": {
      let selector = [];

      // FIXME: Might not be needed anymore after version bump
      // Patch around react hook form management of checkboxes
      if (isArray(value)) selector = value.filter(Boolean);
      else if (isString(value)) selector = [value];

      return {
        selector,
        ...(comment && { comment }),
      };
    }
    case "AnswerEvaluation":
      return { selector: value, ...(comment && { comment }) };
    case "AnswerSkill":
      return { selector: value, ...(comment && { comment }) };
  }
}

export function isAnswerEmpty({
  type,
  value,
  comment,
}: Pick<AnswerFormValues, "type" | "value" | "comment">) {
  switch (type) {
    case "AnswerText":
      return !value;
    case "AnswerSelectorMultiple":
      // FIXME: Might not be needed anymore after version bump
      // Patch around react hook form management of checkboxes
      return (isArray(value) ? value.length === 0 : !value) && !comment;
    case "AnswerSelectorSingle":
    case "AnswerEvaluation":
    case "AnswerSkill":
      return !value && !comment;
  }
}
